/* eslint-disable react/prop-types */
import {Box, Stack, Typography, useTheme} from '@mui/material';
import {memo} from 'react';
import {Handle, Position} from 'reactflow';

function DecisionNode({data}) {
  const theme = useTheme();
  const handleStyle = {transform: 'rotate(0deg)', opacity: '0'};

  return (
    <>
      <Box
        sx={{
          width: '250px',
          height: '200px',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Box
          p={1}
          sx={{
            boxSizing: 'border-box',
            position: 'absolute',
            width: '140px',
            height: '140px',
            background: 'rgba(217, 217, 217, 0.2)',
            border: `3px solid ${theme.palette.grey[500]}`,
            borderRadius: '5px',
            transform: 'rotate(-45deg)',
          }}
        >
          <Stack
            spacing={1}
            p={0}
            sx={{
              transform: 'rotate(45deg)',
              alignSelf: 'center',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <Typography variant='h5' fontSize={data.description && data.description.length > 70 ? 12 : 14}>
              {data.description}
            </Typography>
          </Stack>
        </Box>
        <Handle id='leftSource' style={handleStyle} type='source' position={Position.Left} />
        <Handle id='topSource' style={handleStyle} type='source' position={Position.Top} />
        <Handle id='rightSource' style={handleStyle} type='source' position={Position.Right} />
        <Handle id='bottomSource' style={handleStyle} type='source' position={Position.Bottom} />

        <Handle id='leftTarget' style={handleStyle} type='target' position={Position.Left} />
        <Handle id='topTarget' style={handleStyle} type='target' position={Position.Top} />
        <Handle id='rightTarget' style={handleStyle} type='target' position={Position.Right} />
        <Handle id='bottomTarget' style={handleStyle} type='target' position={Position.Bottom} />
      </Box>
    </>
  );
}

export default memo(DecisionNode);
